import { useLayoutEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { filler, socials } from '../content/copy';
import { Action, Icon, Mark } from './primitives';

function Links() {
  return (
    <>
      <Action size="nav" tone="outline">
        {filler.navigation[0]}
      </Action>
      <Action size="nav" tone="pink">
        <Mark />
      </Action>
      <Action size="nav">{filler.navigation[2]}</Action>
    </>
  );
}
function Socials() {
  return (
    <div className="socials">
      <a href={socials.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
        <Icon name="youtube" />
      </a>
      <a href={socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
        <Icon name="instagram" />
      </a>
    </div>
  );
}
export function Navigation({ home = false }: { home?: boolean }) {
  const [open, setOpen] = useState(false);
  const menu = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const element = menu.current;
    if (!element) return;
    const motion = gsap.context(() => {
      gsap.to(element, {
        autoAlpha: open ? 1 : 0,
        y: open ? 0 : -16,
        duration: 0.35,
        ease: 'power3.out',
      });
      if (open)
        gsap.fromTo(
          element.querySelectorAll('.action'),
          { y: -12, rotation: -5 },
          { y: 0, rotation: 0, stagger: 0.06, duration: 0.45, ease: 'back.out(1.4)' },
        );
    });
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', close);
    return () => {
      motion.revert();
      document.removeEventListener('keydown', close);
    };
  }, [open]);
  return (
    <>
      {home && (
        <div className="opening-navigation">
          <nav aria-label="Social">
            <Action size="nav" tone="youtube" href={socials.youtube} external>
              <Icon name="youtube" />
              <span className="action-label">YouTube</span>
            </Action>
            <Action size="nav" tone="tiktok" href={socials.tiktok} external>
              <Icon name="tiktok" />
              <span className="action-label">TikTok</span>
            </Action>
            <Action size="nav" tone="instagram" href={socials.instagram} external>
              <Icon name="instagram" />
              <span className="action-label">Instagram</span>
            </Action>
          </nav>
        </div>
      )}
      <header className={`navigation ${home ? 'navigation--home' : ''}`}>
        <div className="site-signature-wrap">
          <a className="site-signature" href="/terms">
            © {new Date().getFullYear()} rrroblox.com
          </a>
          <small className="site-signature-note">
            rrroblox.com is not affiliated with Roblox Corporation.
          </small>
        </div>
        <div className="navigation-controls">
          <div
            ref={menu}
            className="navigation-menu"
            id="site-menu"
            inert={!open}
            onClick={() => setOpen(false)}
          >
            <Socials />
            <nav aria-label="Site">
              <Links />
            </nav>
          </div>
          <button
            className="menu-toggle"
            aria-controls="site-menu"
            aria-expanded={open}
            aria-label={open ? 'Close navigation' : 'Open navigation'}
            onClick={() => setOpen((value) => !value)}
          >
            <span className="menu-toggle-placeholder" />
          </button>
        </div>
      </header>
    </>
  );
}
